import type { paths } from "@/@types/Api_Schema"; // generated by openapi-typescript
import createFetchClient, { type Middleware } from "openapi-fetch";
import createTanstackClient from "openapi-react-query";
import { useAuth, type AuthContextType } from "./useAuth";
import { useMemo } from "react";

export function getApi() {
	// const sessionUrl = sessionStorage.getItem("apiUrl");

	const baseUrl = "https://api.huellacarbono.cluster.pre5.wundersolutions.es"
	// if (sessionUrl) {
	// 	baseUrl = sessionUrl;
	// } else if (location.hostname == "localhost") {
	// 	baseUrl = `${location.protocol}//${location.hostname}:3000`;
	// } else if (/\d+\.\d+\.\d+\.\d+/.test(location.hostname)) {
	// 	baseUrl = `${location.protocol}//${location.hostname}:3000`;
	// } else {
	// 	baseUrl = `${location.protocol}//api.${location.hostname}`;
	// }

	const client = createFetchClient<paths>({
		baseUrl,
	});
	return client;
}
export type ApiClient = ReturnType<typeof getApi>;

export function useApi() {
	const authHook = useAuth();
	return useMemo(() => {
		const fetchClient = getApi();
		fetchClient.use(jwtMiddleware(authHook));

		console.log("Creating Tanstack client with auth hook:", authHook);

		return createTanstackClient(fetchClient);
	}, [authHook]);
}

function jwtMiddleware(authHook: AuthContextType): Middleware {
	return {
		async onRequest({ request }) {
			if (request.headers.get("Authorization") == "public") return;
			const token = await authHook.getUpdatedToken();

			if (token != null)
				request.headers.set("Authorization", `Bearer ${token}`);

			return request;
		},
	};
}
